<template>
  <div class="knowledge-technology-box">
    <div class="knowledge-technology-tag">
      <span
        :class="{ active: technologyCategory === '2' }"
        @click="categoryTag('2')"
        >最新技术</span
      >
    </div>
    <div class="knowledge-technology-list">
      <template v-if="technologyList.length > 0">
        <div v-for="el in technologyList" :key="el.id"  @click="info(el.sourceUrl)">
          <h3>{{ el.technicalTitle }}</h3>
          <p>{{ el.technicalDescription }}</p>
          <div>
            <div>
              <p>
                发布人：
                {{ el.publishBy }}
              </p>
              <a-divider type="vertical" />
              <span v-if="el.publishTime"><a-icon type="clock-circle" />{{ dayjs(el.publishTime).format('YYYY-MM-DD') }}</span>
            </div>
            <p>
              <a-tag color="red" v-for="e in el.tags" :key="e"> {{ e }} </a-tag>
            </p>
          </div>
        </div>
      </template>
      <template v-else>
        <a-empty style="padding: 100px 0" />
      </template>
    </div>
    <div style="text-align: right;margin-top: 24px">
      <a-pagination
        show-size-changer
        show-quick-jumper
        hide-on-single-page
        :current="pages.current"
        :total="pages.total"
        @change="paginationChange"
        @showSizeChange="showSizeChange"
      />
    </div>
  </div>
</template>

<script>
import { getOpenTechnologyList } from "@/api/openKnowledge";
import VImg from "@/components/VImg";
import dayjs from 'dayjs'
export default {
  computed: {
    dayjs() {
      return dayjs
    }
  },
  components: {
    VImg,
  },
  data() {
    return {
      pages: {
        total: 0,
        current: 1,
        size: 10,
      },
      technologyCategory: "2",
      technologyList: [],
    };
  },
  mounted() {
    this.openTechnologyList();
  },
  methods: {
    openTechnologyList() {
      let data = {
        isRecommend: this.technologyCategory === "1" ? true : false,
        sortKey:'publish_time'
      };
      getOpenTechnologyList(this.pages, data).then((res) => {
        this.technologyList = res.records;
        this.pages.total = res.total;
      });
    },
    categoryTag(val) {
      this.technologyCategory = val;
      this.pages.current=1
      this.openTechnologyList();
    },
    paginationChange(page, pageSize) {
      this.pages.current = page;
      this.openTechnologyList();
    },
    showSizeChange(current, size) {
      this.pages.size = size;
      this.openTechnologyList();
    },
    info(sourceUrl) {
      window.open(sourceUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.knowledge-technology-box {
  .knowledge-technology-tag {
    display: flex;
    margin-bottom: 8px;
    > span {
      font-size: 18px;
      color: #666666;
      line-height: 64px;
      margin-right: 40px;
      cursor: pointer;
      transition: all 0.3s;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: #262626;
        font-weight: bold;
      }
    }
  }
  .knowledge-technology-list {
    padding: 0 24px;
    background: #fff;
    > div {
      padding: 24px 0;
      cursor: pointer;
      border-bottom: 1px solid #e8e8e8;
      &:last-child {
        border-bottom: 0;
      }
      > h3 {
        font-weight: bold;
        font-size: 16px;
        color: #262626;
        line-height: 22px;
        margin-bottom: 16px;
      }
      > p {
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        margin-bottom: 24px;
      }
      > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
          display: flex;
          align-items: center;
          > p {
            display: flex;
            align-items: center;
            > img {
              width: 24px;
              height: 24px;
              border-radius: 50%;
              margin-right: 8px;
            }
          }
          > span {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
            display: flex;
            align-items: center;
            margin-right: 32px;
            > i {
              margin-right: 4px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
        > p {
          > span {
            border: 0;
            line-height: 24px;
            color: #ea0b06;
            background: rgba(234, 11, 6, 0.04);
          }
        }
      }
    }
  }
}
</style>
